import { FormStore } from '@roc/feature-app-core';
import { createCurrencyField } from '../../../components/temp/componentBuiderTemp';
import { observer } from 'mobx-react';


export const AnnualHoaDues = observer(({ store }: { store: FormStore }) => {
  return (
    <>
      {createCurrencyField({
        label: "Annual HOA Dues",
        fieldName: 'totalAnnualHOADues',
        testId: 'totalAnnualHOADues',
        store,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true
      })}
    </>
  );
});